import { Button, Divider, TextField, Box, FormControl, Grid, Stack, InputAdornment, Dialog, DialogTitle, DialogActions, Backdrop, DialogContent} from "@mui/material";
import classes from "./ParticipanteClasses.css";
import * as React from 'react';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import 'dayjs/locale/es'; // Importa el archivo de localización para español


export default function AvalPrecargado({ identidad, nombres, apellidos, nacimiento, profesion, vivienda, barrio, calle, ave, casa, ciudad,
    departamento, estado, referenciadomicilio, fijo, movil, correo, dependencia, ramo, telefonolaboral, barriolaboral, avenidalaboral,
    callelaboral, casalaboral, ciudadlaboral, departamentolaboral, sueldomensual, otrosingresos, sueldoneto, puesto, tiempolaborarA,
    tiempolaborarM, icono, handleDescargar, openAval1, closeAval1, pdfUrlAval1}) {

    return (
        <>
            <Box>
                <Stack direction="row">
                    <h3 >IV. DATOS PERSONALES - AVAL 1</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container spacing={1}>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval1Identidad" value={identidad} label="Numero de Identidad" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval1Nombres" value={nombres} label="Nombres" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval1Apellidos" value={apellidos} label="Apellidos" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="FechaNacimiento" value={nacimiento} label="Fecha de Nacimiento" variant="outlined"
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <CalendarIcon />
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}/>
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval1Profesion" value={profesion} label="Profesión u Oficio" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                    </Grid>
                </Stack>


                <Stack className={classes.above} direction="row" marginTop={1}>
                    <Grid container>
                        <Stack direction="row" alignItems="center">
                            <label style={{ marginRight: 10 }}><strong>TIPO DE VIVIENDA:</strong></label>
                            <label>{vivienda}</label>
                        </Stack>
                    </Grid>
                </Stack>

                <Stack className={classes.above} direction="row" marginTop={1}>
                    <Grid Container>

                        <Box>
                            <label><strong>Dirección</strong></label>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Barrio" value={barrio} label="Barrio/Col." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Ave" value={ave} label="Ave." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Calle" value={calle} label="Calle." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Casa" value={casa} label="Casa No." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Ciudad" value={ciudad} label="Ciudad" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Departamento" value={departamento} label="Departamento" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>
                        <Box>

                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="estadocivilAval1" value={estado} label="Estado Civil" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 800 }}>
                                <TextField id="aval1ReferenciaDomicilio" value={referenciadomicilio} label="Referencia Domicilio" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval1Fijo" value={fijo} label="Teléfono Fijo" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval1Movil" value={movil} label="Teléfono Movil" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                            <FormControl sx={{ m: 1, width: 300 }} >
                                <TextField id="aval1Correo" value={correo} label="Correo Electrónico" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                        </Box>
                    </Grid>
                </Stack>
            </Box>

            <Box>
                <Stack direction="row">
                    <h3 >V. INFORMACIÓN LABORAL - AVAL 1</h3>
                </Stack>

                <Stack direction="row">
                    <Grid container>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval1Dependencia" value={dependencia} label="Dependencia donde trabaja" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval1Ramo" value={ramo} label="Ramo" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 350 }}>
                            <TextField id="aval1TelefonoTrabajo" value={telefonolaboral} label="Teléfono" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <Box>
                            <strong>Dirección</strong>
                            <Box>
                                <Stack direction="row">
                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1BarrioTrabajo" value={barriolaboral} label="Barrio/Col." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1AveTrabajo" value={avenidalaboral} label="Ave." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1CalleTrabajo" value={callelaboral} label="Calle" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1CasaTrabajo" value={casalaboral} label="Casa No." variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1CiudadTrabajo" value={ciudadlaboral} label="Ciudad" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>

                                    <Box sx={{ width: 200 }}>
                                        <TextField id="aval1Departamentotrabajo" value={departamentolaboral} label="Departamento" variant="standard" InputProps={{ readOnly: true }} />
                                    </Box>
                                </Stack>
                            </Box>
                        </Box>

                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoMensualAval1" value={sueldomensual} label="Sueldo Mensual" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="otrosIngresosAval1" value={otrosingresos} label="Otros ingresos (detalle)" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 200 }}>
                            <TextField id="sueldoNetoAval1" value={sueldoneto} label="Sueldo Neto" variant="standard" InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        L.
                                    </InputAdornment>
                                ),
                                readOnly: true
                            }}
                            />
                        </FormControl>
                        <FormControl sx={{ m: 1, width: 300 }}>
                            <TextField id="aval1Puesto" value={puesto} label="Puesto" variant="standard" InputProps={{ readOnly: true }} />
                        </FormControl>
                        <Box>
                            <Box>
                                <label><strong>Tiempo De Laborar</strong></label>
                            </Box>
                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval1Years" value={tiempolaborarA} label="Años" variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>

                            <FormControl sx={{ m: 1, width: 300 }}>
                                <TextField id="aval1Meses" label="Meses" value={tiempolaborarM} variant="standard" InputProps={{ readOnly: true }} />
                            </FormControl>
                        </Box>
                    </Grid>

                </Stack>
            </Box>
            <Box marginTop={3}>
                <h3>IDENTIDAD DEL AVAL 1 EN FORMATO PDF</h3>
                <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <Box
                        style={{
                            padding: '50px',
                            width: '700px',
                            textAlign: 'center',
                            borderColor: 'gray',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <img src={icono} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'gray' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleDescargar}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: '#AD8401' }}
                        >
                            Ver Archivo PDF
                        </Button>
                        <p>Haz clic en el botón para visualizar la identidad del aval 1 en PDF</p>
                        <Backdrop open={openAval1} onClick={closeAval1} style={{ zIndex: 1 }}>
                            <Dialog
                                open={openAval1}
                                onClose={closeAval1}
                                maxWidth="md"
                                fullWidth
                            >
                                <DialogTitle textAlign={'center'}>Identidad Del Aval 1</DialogTitle>
                                <DialogContent>
                                    <iframe
                                        src={pdfUrlAval1}
                                        width="100%"
                                        height="450px"
                                        style={{ border: 'none' }}
                                    />
                                </DialogContent>
                            </Dialog>
                        </Backdrop>
                    </Box>
                </Box>
            </Box>
            <Divider style={{ marginTop: 5 }} />
        </>
    );
}
